import palette from '../palette';

export default {
  root: {
    caretColor: palette.primary.main,
  },
  inputTypeSearch: {
    appearance: 'none',
    '&::-webkit-search-decoration': {
      appearance: 'none',
    },
    '&::-webkit-search-cancel-button': {
      appearance: 'none',
    },
    '&::-webkit-search-results-button': {
      appearance: 'none',
    },
    '&::-webkit-search-results-decoration': {
      display: 'none',
    },
  },
};
